module.exports = __webpack_public_path__ + "static/image-dawn-37bc946d9cc798f04619e95510f1733d.svg";